import { render, staticRenderFns } from "./BaseSectionTitle.vue?vue&type=template&id=346af663&"
import script from "./BaseSectionTitle.vue?vue&type=script&lang=js&"
export * from "./BaseSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports